import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import UserStore from "../../stores/userStore"
import OrganizationService from "../../services/organizationService"
import UserService from "../../services/userService"
import { cloneDeep } from "lodash"
import { translate } from "../../utils/utils"
import OrderDeliveryService from "../../services/orderDeliveryService"
import FlashStore from "../../stores/flashStore"
import { Button, Col, FormGroup, Row } from "reactstrap"
import { Select, TextInput } from "../ui/form-control"
import { FormattedMessage } from "react-intl"
import { Modal } from "../ui/Modal"

const ChangeManagerOrderModal = (props) => {
  const [users, setUsers] = useState([])
  const [user, setUser] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    UserService.getManagers().then((res) => {
      if (res.code === 200) {
        let userFormatted = []
        for (let user of res.data) {
          let userFormat = cloneDeep(user)
          userFormat.formatName = `${user.admin === true ? `(${translate({ id: "role.user.adminOrganization" })})` : ""} ${user.firstName} ${user.lastName}, ${user.email}`
          userFormatted.push(userFormat)
        }
        setUsers(userFormatted)
        setUser(undefined)
        setLoading(false)
      }
    })
  }, [])

  const onSave = () => {
    if (user !== undefined && props.id !== undefined) {
      OrderDeliveryService.assignManager({idUser: user, orderDeliveryRequestGroupId: props.id})
        .then((res) => {
          if (res.code === 200) {
            FlashStore.successNow(translate({ id: "common.save.success" }), 4000)
            setUser(undefined)
            props.onClose(true)
          } else {
            FlashStore.errorNow(translate({ id: "service.serverError" }), 4000)
            props.onClose(false)
          }
        })
        .catch((e) => {
          FlashStore.errorNow(translate({ id: "service.serverError" }), 4000)
          props.onClose(false)
        })
    }
  }

  if (props.isBlock === true) {
    return (
      <div>
        {loading === true ? (
          <Row>
            <div className={"w-100"}>
              <div style={{ minHeight: 100 }} className={"d-flex align-items-center justify-content-center"}>
                <div className="fa-1x">
                  <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
                </div>
              </div>
            </div>
          </Row>
        ) : (
          <Row>
            <Col xs={12} lg={4}>
              <FormGroup>
                <Select
                  searchable
                  filterOption={(option, value) => {
                    if (value.length > 0) return option?.formatName.toLowerCase().includes(value?.toLowerCase())
                    return true
                  }}
                  values={users}
                  value={user}
                  labelKey={"formatName"}
                  valueKey={"id"}
                  label={
                    <span className={"form-group f-label"}>
                      <FormattedMessage id={"form.field.user"} />
                    </span>
                  }
                  onChange={(v) => {
                    setUser(v.id)
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
        )}
      </div>
    )
  }

  return (
    <Modal
      isModal={false}
      isShow={props.isShow}
      onClose={() => {
        props.onClose(false)
      }}
      title={<FormattedMessage id={"deliveryOrders.orderBlock.orderActions.assignManager"} />}
      top
    >
      {loading === true ? (
        <Row>
          <div className={"w-100"}>
            <div style={{ minHeight: 100 }} className={"d-flex align-items-center justify-content-center"}>
              <div className="fa-1x">
                <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
              </div>
            </div>
          </div>
        </Row>
      ) : (
        <Row>
          <Col xs={12}>
            <Select
              filterOption={(option, value) => {
                if (value.length > 0) return option?.formatName.toLowerCase().includes(value?.toLowerCase())
                return true
              }}
              searchable
              values={users}
              value={user}
              labelKey={"formatName"}
              valueKey={"id"}
              label={
                <span className={"form-group f-label"}>
                  <FormattedMessage id={"form.field.user"} />
                </span>
              }
              onChange={(v) => {
                setUser(v.id)
              }}
            />
          </Col>
          <Col xs={12} className={"d-flex"}>
            <FormGroup className="btn-controls">
              <Row className="no-gutters" style={{ justifyContent: "flex-start" }}>
                {user !== undefined && (
                  <Button
                    color={"primary"}
                    onClick={() => {
                      onSave()
                    }}
                  >
                    <FormattedMessage id={"crudForm.button.save"} />
                  </Button>
                )}
                <Button
                  onClick={() => {
                    props.onClose(false)
                  }}
                >
                  <FormattedMessage id={"crudForm.button.cancel"} />
                </Button>
              </Row>
            </FormGroup>
          </Col>
        </Row>
      )}
    </Modal>
  )
}

ChangeManagerOrderModal.propTypes = {}

export default ChangeManagerOrderModal
